/* eslint-disable */
import React, { useState } from 'react';

import { useProperties } from '~/properties';
import { useMatrix } from '~/entrataReports';

import NoResults from '@/noResults/NoResults';
import BrickellFirst from './properties/BrickellFirst.jsx';
import BrickellWest from './properties/BrickellWest.jsx';
import Colony from './properties/Colony.jsx';
import CCT from './properties/CountryClubTowers.jsx';
import FBM from './properties/FBM.jsx';
import G37 from './properties/G37.jsx';
import IYV from './properties/IYC.jsx';
import MiamiBayClub from './properties/MiamiBayClub.jsx';
import MiamiRiver from './properties/MiamiRiver.jsx';
import RoyalPalmns from './properties/RoyalPalms.jsx';
import Stadium from './properties/StadiumTower.jsx';
import Reflections from './properties/Reflections.jsx';
import SeaViewAtDania from './properties/SeaViewAtDania.jsx';
import {
    FormControl, InputLabel, Select, MenuItem
} from '@material-ui/core';


const matrixes = {
    615392: BrickellFirst,
    643421: BrickellWest,
    615413: Colony,
    615395: CCT,
    615398: FBM,
    615399: G37,
    615401: IYV,
    615405: MiamiBayClub,
    615406: MiamiRiver,
    615408: RoyalPalmns,
    615410: Stadium,
    1111029: Reflections,
    1224825: SeaViewAtDania
};

const reduceProperties = (properties = []) => properties.reduce((acc, property) => ({
    ...acc,
    [property.id]: property.code
}), {});

const GrowthRateNotConfigured = props => {

    const { data } = props;

    if (data){
        for (const key in data) {
            if (data[key].growth_rate_not_configured){

                return (
                    <div style={{ color: 'red' }}>
                    ATTENTION: there is some Unit Types not configured: { data[key].unit_type }
                    </div>
                );
            };
        }
    }

    return <div></div>;
};
const MatrixRouter = props => {

    const { match } = props;
    const { property_id } = match.params;

    const [matrixType, setMatrixType] = useState('market');
    const { data: properties } = useProperties();

    const propCodes = reduceProperties(properties);

    const Matrix = matrixes[propCodes[property_id]];

    const { data, isLoading } = useMatrix(property_id, { enabled: !!Matrix && matrixType === 'market' });

    const handeSelect = e => {
        setMatrixType(e.target.value);
    };


    // market
    // current
    // current - special

    if (Matrix) {
        return (
            <div>
                <FormControl style={styles.select}>
                    <InputLabel id='select'>Matrix Type</InputLabel>
                    <Select labelId='select' value={matrixType} onChange={handeSelect}>
                        <MenuItem value={'market'}>Market Rent</MenuItem>
                        <MenuItem value={'current'}>Current Rent</MenuItem>
                        {/* <MenuItem value={30}>Current Te</MenuItem> */}
                    </Select>
                </FormControl>
                <GrowthRateNotConfigured data={data} />
                <Matrix data={data} isLoading={isLoading} matrixType={matrixType}/>
            </div>
        );
    }

    return <NoResults message='Matrix for this property does not exist' redirectPath='/properties'/>;

};

const styles = {
    select: {
        float: 'right',
        marginRight: '15px'
    }
};

export default MatrixRouter;
